var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "main",
    { staticClass: "col content-spacing", attrs: { role: "main" } },
    [
      _vm.viewData.loading
        ? _c("loading-list")
        : _c(
            "b-container",
            [
              _c(
                "b-row",
                [
                  _c("b-col", [
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom"
                      },
                      [
                        _c("h1", { staticClass: "h2" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.viewData.id
                                  ? `Editar`
                                  : "Novo Cupom vs Comercializador"
                              ) +
                              "\n          "
                          )
                        ])
                      ]
                    )
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c("b-breadcrumb", {
                        attrs: {
                          items: [
                            {
                              text: "Lista de Cupons vs Comercializador",
                              href: `#/coupon-owners/${this.state.couponId}`
                            },
                            {
                              text: "Cadastro de Cupons vs Comecializadores",
                              href: "#",
                              active: true
                            }
                          ]
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-card",
                        [
                          _c(
                            "b-form",
                            [
                              _c("error-container", {
                                attrs: { errors: _vm.viewData.errors || [] }
                              }),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                { attrs: { label: "Comissão" } },
                                [
                                  _c("b-form-input", {
                                    staticClass: "text-right",
                                    attrs: {
                                      placeholder:
                                        "Informe o valor da comissão",
                                      state: _vm.isOk("comission")
                                    },
                                    on: {
                                      keypress: function($event) {
                                        return _vm.isNumber($event)
                                      }
                                    },
                                    model: {
                                      value: _vm.state.comission,
                                      callback: function($$v) {
                                        _vm.$set(_vm.state, "comission", $$v)
                                      },
                                      expression: "state.comission"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    id: "input-group-1",
                                    label: "Selecione o Cupom",
                                    "label-for": "input-1"
                                  }
                                },
                                [
                                  _c("b-form-select", {
                                    attrs: {
                                      disabled: true,
                                      options: _vm.state.coupons,
                                      multiple: false
                                    },
                                    model: {
                                      value: _vm.state.couponId,
                                      callback: function($$v) {
                                        _vm.$set(_vm.state, "couponId", $$v)
                                      },
                                      expression: "state.couponId"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    id: "input-group-1",
                                    label: "Selecione o Comercializador",
                                    "label-for": "input-1"
                                  }
                                },
                                [
                                  _c("b-form-select", {
                                    attrs: {
                                      options: _vm.state.traders,
                                      multiple: false
                                    },
                                    model: {
                                      value: _vm.state.accountId,
                                      callback: function($$v) {
                                        _vm.$set(_vm.state, "accountId", $$v)
                                      },
                                      expression: "state.accountId"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("submit-button", {
                                attrs: {
                                  action: () => _vm.save(),
                                  label: "Salvar"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }